module.exports = __webpack_public_path__ + "entry-41b28522/bahne-groth-photo-101b8426dd2cdb9d3bf8b502ad22f11b.webp";